import React from "react";
import "gantt-task-react/dist/index.css";
import Button from '@mui/material/Button';
import { ViewMode } from "gantt-task-react";
type ViewSwitcherProps = {
  viewMode: ViewMode;
  onViewModeChange: (viewMode: ViewMode) => void;
};
export const ViewSwitcher: React.FC<ViewSwitcherProps> = ({
  viewMode,
  onViewModeChange,
}) => {
  return (
    <div className="ViewContainer">
      {/* 
      <Button 
        variant={viewMode==ViewMode.Day ? "contained" : "outlined"} 
        onClick={() => onViewModeChange(ViewMode.Day)}>
        Day
      </Button>
      */}
      <Button
        variant={viewMode==ViewMode.Week ? "contained" : "outlined"} 
         onClick={() => onViewModeChange(ViewMode.Week)}
      >
        Week
      </Button>

      <Button
        variant={viewMode==ViewMode.Month ? "contained" : "outlined"} 
        onClick={() => onViewModeChange(ViewMode.Month)}
      >
        Month
      </Button>
      <Button
        variant={viewMode==ViewMode.QuarterYear ? "contained" : "outlined"} 
        onClick={() => onViewModeChange(ViewMode.QuarterYear)}
      >
        Quarter
      </Button>
      <Button
        variant={viewMode==ViewMode.Year ? "contained" : "outlined"} 
        onClick={() => onViewModeChange(ViewMode.Year)}
      >
        Year
      </Button>
    </div>
  );
};
